import React from 'react'
import { Link } from 'react-router-dom'

import SEO from '../components/SEO'
import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './ppf-kaplama.css'

const PpfKaplama = () => {
  return (
    <div className="ppf-page-container teleport-dashboard-layout">
      {/* Merkezi Teknik SEO Meta Yönetimi */}
      <SEO
        title="PPF Kaplama İstanbul | Şeffaf Boya Koruma Filmi | ATEŞ AUTO DETAILING"
        description="Aracınızın boya yüzeyini yol taşları, hafif sürtünmeler ve çevresel etkenlere karşı korumaya yardımcı olan şeffaf PPF boya koruma filmi uygulaması. Beşiktaş Conrad stüdyosu."
        canonicalPath="/ppf-kaplama"
      />

      <aside className="ppf-page-sidebar-wrapper teleport-dashboard-sidebar">
        <Navigation />
      </aside>

      <main id="tq-main" className="ppf-page-content-wrapper teleport-dashboard-content">
        {/* Hero Bölümü */}
        <section className="ppf-hero">
          <nav aria-label="Breadcrumb" className="ppf-breadcrumb">
            <Link to="/">ANA SAYFA</Link>
            <span className="ppf-breadcrumb-separator">/</span>
            <Link to="/arac-koruma">ARAÇ KORUMA</Link>
            <span className="ppf-breadcrumb-separator">/</span>
            <span aria-current="page">PPF KAPLAMA</span>
          </nav>

          <h1 className="ppf-headline">
            İstanbul PPF Kaplama: Şeffaf Boya Koruma Filmi Uygulaması
          </h1>

          <p className="ppf-description">
            PPF (Paint Protection Film), aracın orijinal boya yüzeyini günlük yol koşullarında karşılaşılan taş izleri,
            hafif yüzeysel sürtünmeler ve çevresel yıpranmalara karşı korumaya yardımcı olan şeffaf bir yüzey kaplamasıdır.
            Beşiktaş stüdyomuzda aracınızın yapısına uygun çözümleri değerlendirmek için bizimle iletişime geçebilirsiniz.
          </p>

          <div className="ppf-actions">
            <a href="tel:+905346442153" className="ppf-btn-primary">
              TEKLİF AL / RANDEVU
            </a>
            <a
              href="https://wa.me/905346442153"
              target="_blank"
              rel="noreferrer noopener"
              className="ppf-btn-secondary"
            >
              WHATSAPP BİLGİ
            </a>
          </div>
        </section>

        {/* Gövde / İçerik Alanı */}
        <div className="ppf-body">
          {/* PPF Faaliyet Alanı Görsel Vitrini */}
          <div className="ppf-showcase-section">
            <div className="ppf-showcase-header">
              <span className="ppf-showcase-badge">PPF UYGULAMA FAALİYET ALANI</span>
              <h2 className="ppf-showcase-title">Stüdyomuzda Şeffaf TPU PPF Montajı &amp; Yüzey Detayları</h2>
            </div>
            <div className="ppf-showcase-grid">
              <div className="ppf-showcase-card">
                <div className="ppf-showcase-img-wrap">
                  <img
                    src="https://images.pexels.com/photos/36021355/pexels-photo-36021355.jpeg?auto=compress&cs=tinysrgb&w=1500"
                    alt="Beşiktaş Conrad stüdyosunda spor araca şeffaf TPU PPF film montajı"
                    loading="lazy"
                    decoding="async"
                    className="ppf-showcase-img"
                  />
                  <span className="ppf-img-tag">MONTAJ AŞAMASI</span>
                </div>
                <p className="ppf-showcase-caption">
                  Kapalı stüdyo ortamında panel hatlarına sıfır toz toleransı ve gerdirme tekniğiyle TPU film montajı.
                </p>
              </div>

              <div className="ppf-showcase-card">
                <div className="ppf-showcase-img-wrap">
                  <img
                    src="https://images.pexels.com/photos/30837753/pexels-photo-30837753.jpeg?auto=compress&cs=tinysrgb&w=1500"
                    alt="PPF boya koruma filmi sonrası kusursuz optik berraklık ve kenar kıvrımları"
                    loading="lazy"
                    decoding="async"
                    className="ppf-showcase-img"
                  />
                  <span className="ppf-img-tag">YÜZEY BERRAKLIĞI</span>
                </div>
                <p className="ppf-showcase-caption">
                  Işık altında self-healing polimer katmanın sağladığı ayna berraklığı ve görünmez kenar bitişleri.
                </p>
              </div>
            </div>
          </div>

          {/* Bölüm 1: PPF Nedir */}
          <section className="ppf-section">
            <h2 className="ppf-section-title">
              PPF (Paint Protection Film) Nedir ve Boyayı Nasıl Korumaya Yardımcı Olur?
            </h2>
            <p className="ppf-paragraph">
              PPF, otomotiv endüstrisinde araç boyasını dış fiziki etkenlerden korumak amacıyla geliştirilmiş,
              yüksek esneklik ve optik berraklığa sahip şeffaf bir poliüretan film tabakasıdır. Aracın fabrika çıkışındaki
              orijinal verniğini doğrudan örtmeyen geleneksel uygulamaların aksine, boyanın üzerine fiziksel bir bariyer
              oluşturarak yüzeyi dış dünya ile temas noktası olmaktan çıkarır.
            </p>

            <div className="ppf-subsection-grid">
              <div className="ppf-info-card">
                <h3 className="ppf-card-subtitle">PPF&apos;nin fiziksel koruma mantığı</h3>
                <p className="ppf-card-text">
                  Filmin temel koruma mekanizması, darbe enerjisini soğurma ve dağıtma prensibine dayanır. Seyir halindeyken
                  yüzeye çarpan yabancı cisimlerin kinetik enerjisi, filmin elastik polimer yapısı tarafından emilir.
                  Bu sayede darbenin doğrudan sert ve kırılgan olan vernik katmanına ulaşıp boyayı çatlatması veya koparması
                  önemli ölçüde azaltılmaya yardımcı olur.
                </p>
              </div>

              <div className="ppf-info-card">
                <h3 className="ppf-card-subtitle">PPF hangi dış etkenlere karşı koruma sağlar?</h3>
                <p className="ppf-card-text">
                  Yolculuk esnasında öndeki araçlardan fırlayan küçük taşlar, yol mıcırları, böcek ve sinek asitleri,
                  ağaç reçineleri, kış aylarında yollara uygulanan tuz ve kimyasallar ile güneşin yaydığı UV ışınlarının
                  boyada oluşturabileceği matlaşma etkilerine karşı yüzeyin korunmasına destek olur. Ayrıca park esnasındaki
                  hafif sürtünmelerde de vernik hasarını sınırlamada rol oynar.
                </p>
              </div>
            </div>
          </section>

          {/* Bölüm 2: Hangi Bölgelere Uygulanabilir */}
          <section className="ppf-section">
            <h2 className="ppf-section-title">
              PPF Kaplama Hangi Bölgelere Uygulanabilir?
            </h2>
            <p className="ppf-paragraph">
              Boya koruma filmi, araç sahiplerinin kullanım alışkanlıklarına ve bütçe planlamalarına bağlı olarak
              aracın tamamına uygulanabileceği gibi, yalnızca yol koşullarında en yüksek darbe riskine maruz kalan
              kritik panellere de uygulanabilir. Genel olarak tercih edilen uygulama bölgeleri şunlardır:
            </p>

            <div className="ppf-subsection-grid">
              <div className="ppf-info-card">
                <h3 className="ppf-card-subtitle">Kaput ve ön tampon</h3>
                <p className="ppf-card-text">
                  Aerodinamik olarak yol rüzgarını ve yoldan seken cisimleri ilk karşılayan alanlar motor kaputu ve
                  ön tampondur. Bu bölgelerin kaplanması, özellikle otoyol ve şehirlerarası sürüşlerde taş izlerinin
                  en aza indirilmesinde en sık tercih edilen adımdır.
                </p>
              </div>

              <div className="ppf-info-card">
                <h3 className="ppf-card-subtitle">Çamurluklar ve ayna kapakları</h3>
                <p className="ppf-card-text">
                  Ön çamurluklar ve dış dikiz ayna kapakları, yan rüzgar akımlarında savrulan partiküllerden ve
                  dar alanlarda sürtünme riskinden en çok etkilenen bileşenler arasında yer alır.
                </p>
              </div>

              <div className="ppf-info-card">
                <h3 className="ppf-card-subtitle">Kapı ve marşpiyel bölgeleri</h3>
                <p className="ppf-card-text">
                  Tekerleklerin arkasından fırlayan kum ve çakıl zerreciklerinin çarptığı marşpiyel altları,
                  araç iniş binişlerinde ayakkabı darbelerine maruz kalan kapı eşikleri ve dar otoparklarda diğer
                  araç kapılarının temas edebileceği kapı yüzeyleri koruma altına alınabilir.
                </p>
              </div>

              <div className="ppf-info-card">
                <h3 className="ppf-card-subtitle">Far ve yüksek riskli yüzeyler</h3>
                <p className="ppf-card-text">
                  Polikarbonat malzemeden üretilen modern far camları, bagaj yükleme eşikleri ve kapı açma kolu iç çukurları,
                  günlük kullanımda tırnak ve valiz çiziklerine karşı lokal koruma filmleriyle muhafaza edilebilir.
                </p>
              </div>
            </div>
          </section>

          {/* Bölüm 3: Parlak ve Mat PPF */}
          <section className="ppf-section">
            <h2 className="ppf-section-title">
              Parlak ve Mat PPF Seçenekleri
            </h2>
            <p className="ppf-paragraph">
              Boya koruma filmleri temel olarak iki farklı görsel yüzey karakteri ile tercih edilebilmektedir:
            </p>
            <div className="ppf-subsection-grid">
              <div className="ppf-info-card">
                <h3 className="ppf-card-subtitle">Parlak (Gloss) PPF</h3>
                <p className="ppf-card-text">
                  Yüksek optik geçirgenliğe sahip şeffaf filmdir. Aracın orijinal boya rengini, metalik zerreciklerini
                  ve derinliğini değiştirmeden yansıtır. Aracın fabrikasyon parlak yüzey formunu korumak isteyen
                  kullanıcılar için standart çözümdür.
                </p>
              </div>
              <div className="ppf-info-card">
                <h3 className="ppf-card-subtitle">Mat (Matte / Satin) PPF</h3>
                <p className="ppf-card-text">
                  Orijinal fabrikasyon mat boyaya sahip araçların mat dokusunu bozmadan korunması amacıyla kullanılabileceği
                  gibi; parlak boyalı bir araca saten ve mat bir görsel doku kazandırmak amacıyla da değerlendirilebilir.
                  Böylece renk değiştirmeden mat bir görünüm elde edilirken boya koruması da sağlanmış olur.
                </p>
              </div>
            </div>
          </section>

          {/* Bölüm 4: Uygulama Süreci */}
          <section className="ppf-section">
            <h2 className="ppf-section-title">
              Profesyonel PPF Uygulama Süreci
            </h2>
            <p className="ppf-paragraph">
              Boya koruma filminin yüzeye doğru tutunması ve optik olarak kusursuz görünmesi, titizlikle yürütülen
              çok adımlı bir yüzey hazırlığı ve montaj disiplinine bağlıdır:
            </p>

            <div className="ppf-process-grid">
              <div className="ppf-process-card">
                <span className="ppf-step-badge">ADIM 01</span>
                <h3 className="ppf-process-title">Yüzey hazırlığı</h3>
                <p className="ppf-process-text">
                  Filmin uygulanacağı boya yüzeyindeki mevcut çizikler ve kusurlar incelenir. Gerektiğinde yüzey pürüzlerini
                  gidermek amacıyla <Link to="/boya-duzeltme" className="ppf-link">boya düzeltme</Link> ve parlaklığı
                  dengeleyen <Link to="/polisaj" className="ppf-link">polisaj</Link> işlemleri ön hazırlık olarak değerlendirilir.
                </p>
              </div>

              <div className="ppf-process-card">
                <span className="ppf-step-badge">ADIM 02</span>
                <h3 className="ppf-process-title">Temizlik ve dekontaminasyon</h3>
                <p className="ppf-process-text">
                  Yüzeydeki demir tozu, katran, reçine ve organik kalıntılar özel kimyasallar ve kil uygulamasıyla
                  arındırılır. Filmin boyaya yapışmasını engelleyecek her türlü yağ ve kirlilik yüzeyden tamamen uzaklaştırılır.
                </p>
              </div>

              <div className="ppf-process-card">
                <span className="ppf-step-badge">ADIM 03</span>
                <h3 className="ppf-process-title">Filmin yüzeye uygulanması</h3>
                <p className="ppf-process-text">
                  Tozdan arındırılmış kapalı stüdyo ortamında, montaj solüsyonları yardımıyla film panellere dikkatlice
                  yerleştirilir. Özel ragleler vasıtasıyla alttaki sıvı ve hava tahliye edilerek filmin boyaya teması sağlanır.
                </p>
              </div>

              <div className="ppf-process-card">
                <span className="ppf-step-badge">ADIM 04</span>
                <h3 className="ppf-process-title">Kenar ve panel birleşimlerinin kontrolü</h3>
                <p className="ppf-process-text">
                  Panel kenarları, köşe bitişleri ve kıvrımlar incelenir. Filmin kenar bölgelerinin zamanla kalkma yapmaması
                  için uygun kuruma ve yapışma kontrolleri gerçekleştirilir.
                </p>
              </div>

              <div className="ppf-process-card">
                <span className="ppf-step-badge">ADIM 05</span>
                <h3 className="ppf-process-title">Son kalite kontrol</h3>
                <p className="ppf-process-text">
                  Kuruma sürecinin ardından ışık altında tüm paneller taranır. Kabarcık, gerginlik hatası veya optik sapma
                  olup olmadığı detaylıca gözden geçirildikten sonra araç teslim sürecine hazır hale getirilir.
                </p>
              </div>
            </div>
          </section>

          {/* Bölüm 5: Taş İzleri */}
          <section className="ppf-section">
            <h2 className="ppf-section-title">
              PPF Kaplama Taş İzlerine Karşı Koruma Sağlar mı?
            </h2>
            <p className="ppf-paragraph">
              PPF, otomotiv yüzeylerinde yol taşlarına karşı koruma sağlamaya yardımcı olmak üzere geliştirilmiş en etkili
              fiziksel yöntemlerden biridir. Karayolunda seyir halindeyken öndeki araçların lastiklerinden fırlayan küçük çakıl
              ve mıcır parçaları, filmin elastik tabakasına çarptığında enerjisini kaybeder. Bu sayede taşın doğrudan vernik
              tabakasını delmesi veya boyayı parça halinde koparması riski önemli ölçüde hafifletilmiş olur.
            </p>
            <p className="ppf-paragraph">
              Bununla birlikte, hiçbir koruma filmi fiziksel olarak sınırsız bir mukavemete sahip değildir. Aşırı yüksek hızlarda
              çarpan büyük, sivri uçlu sert cisimler veya çok şiddetli darbeler filmin kapasitesini aşabilir. Bu nedenle
              PPF kaplama, boya hasarını kesin olarak sıfıra indiren sihirli bir kalkan değil; gündelik yol koşullarındaki
              tipik taş izlerini ve sürtünme etkilerini minimize etmeye <strong>yardımcı olan</strong> üst düzey bir koruyucu bariyerdir.
            </p>
          </section>

          {/* Bölüm 6: PPF vs Seramik */}
          <section className="ppf-section">
            <h2 className="ppf-section-title">
              PPF ile Seramik Kaplama Arasındaki Fark
            </h2>
            <p className="ppf-paragraph">
              Araç sahipleri tarafından sıklıkla birbiriyle kıyaslanan bu iki uygulama, temelde tamamen farklı koruma
              mekanizmalarına sahiptir ve birbirlerinin doğrudan ikamesi olmaktan ziyade tamamlayıcı niteliktedir:
            </p>

            <div className="ppf-compare-container">
              <div className="ppf-compare-card highlight">
                <h3 className="ppf-compare-heading">PPF Kaplama (Boya Koruma Filmi)</h3>
                <ul className="ppf-compare-list">
                  <li><strong>Fiziksel film tabakası:</strong> Boyanın üzerine gerilen esnek, gözle görülür kalınlıkta bir polimer örtüdür.</li>
                  <li><strong>Darbe direnci:</strong> Yol taşları, mıcır çarpmaları ve hafif mekanik sürtünmelere karşı koruma odaklıdır.</li>
                  <li><strong>Uygulama alanı:</strong> Ön tampon, kaput veya tüm gövde gibi riske açık panellere uygulanabilir.</li>
                </ul>
              </div>

              <div className="ppf-compare-card">
                <h3 className="ppf-compare-heading">Seramik Kaplama</h3>
                <ul className="ppf-compare-list">
                  <li><strong>Sıvı kimyasal koruma:</strong> Vernik gözeneklerine nüfuz eden ve kovalent bağ kuran nano-seramik tabakadır.</li>
                  <li><strong>Yüzey ve kimyasal direnç:</strong> Yüksek parlaklık, hidrofobik su iticilik, kolay temizlenme ve UV koruması sağlar.</li>
                  <li><strong>Darbe koruması yoktur:</strong> Taş çarpmalarına veya derin mekanik çizilmelere karşı fiziksel bariyer oluşturmaz.</li>
                </ul>
              </div>
            </div>

            <p className="ppf-paragraph">
              En kapsamlı koruma kurgusunda, yüksek darbe riskine sahip ön panellere PPF uygulanırken, filmlenmeyen diğer yüzeylere
              veya filmin üzerine ek hidrofobiklik kazandırmak amacıyla <Link to="/seramik-kaplama" className="ppf-link">seramik kaplama</Link> uygulanması
              tercih edilebilir. Farklı çözümlerin kıyaslaması için <Link to="/arac-koruma" className="ppf-link">araç koruma çözümleri</Link> sayfamızı
              da inceleyebilirsiniz.
            </p>
          </section>

          {/* Bölüm 7: PPF vs Araç Kaplama */}
          <section className="ppf-section">
            <h2 className="ppf-section-title">
              PPF ile Araç Kaplama Arasındaki Fark
            </h2>
            <p className="ppf-paragraph">
              Kullanıcıların sıklıkla karıştırdığı bir diğer ayrım ise şeffaf PPF kaplama ile renk değişim folyoları arasındaki farktır:
            </p>
            <p className="ppf-paragraph">
              <strong>PPF (Boya Koruma Filmi):</strong> Aracın orijinal rengini değiştirmeyen şeffaf bir koruyucu katmandır.
              Temel amacı boyayı dış darbelerden, taş izlerinden ve yıpranmalardan korumaktır. Kalınlığı ve esnek yapısı
              fiziksel dayanıklılık üzerine optimize edilmiştir.
            </p>
            <p className="ppf-paragraph">
              <strong>Araç Kaplama (Folyo / Renk Değişimi):</strong> Aracın görsel rengini, parlaklığını veya dokusunu
              (örneğin parlaktan mat renge, beyazdan antrasite) değiştirmek amacıyla üretilen dökme vinil folyolardır.
              Temel amacı estetik ve görsel kişiselleştirmedir; boya koruma filmi kadar yüksek bir darbe emme ve taş direnci sunmaz.
              Renk değişimiyle ilgilenen araç sahipleri için <Link to="/arac-kaplama" className="ppf-link">araç kaplama ve renk değişimi</Link> hizmetimiz
              ayrı bir uzmanlık alanı olarak sunulmaktadır.
            </p>
          </section>

          {/* Bölüm 8: Fiyatı Belirleyen Faktörler */}
          <section className="ppf-section">
            <h2 className="ppf-section-title">
              PPF Kaplama Fiyatını Belirleyen Faktörler
            </h2>
            <p className="ppf-paragraph">
              PPF kaplama uygulamalarında tek tip sabit bir fiyat bulunmamaktadır. Her aracın gereksinimleri ve uygulama
              kapsamı farklılık gösterdiğinden, maliyeti belirleyen başlıca unsurlar şunlardır:
            </p>

            <ul className="ppf-compare-list">
              <li><strong>Araç segmenti ve gövde boyutu:</strong> Kompakt bir hatchback ile geniş bir SUV veya uzun şaseli bir lüks sedanın yüzey alanı farklıdır.</li>
              <li><strong>Uygulama kapsamı:</strong> Yalnızca kaput ve tampon gibi ön koruma alanları ile aracın tüm gövdesinin kaplanması arasındaki malzeme ve işçilik farkı.</li>
              <li><strong>Panel formlarının karmaşıklığı:</strong> Keskin hatlara, hava girişlerine ve aerodinamik kıvrımlara sahip spor araçlarda işçilik süresinin artması.</li>
              <li><strong>Ön hazırlık ihtiyacı:</strong> Uygulama öncesinde boya yüzeyinde mevcut olan çiziklerin temizlenmesi için gereken yüzey düzeltme seviyesi.</li>
              <li><strong>Film tipi:</strong> Standart parlak film veya mat efektli koruma filmi seçenekleri.</li>
            </ul>

            <p className="ppf-paragraph">
              Aracınıza en uygun uygulama kapsamını belirlemek ve şeffaf bir teklif almak için stüdyomuzla iletişime geçebilirsiniz.
            </p>
          </section>

          {/* Bölüm 9: Bakım */}
          <section className="ppf-section">
            <h2 className="ppf-section-title">
              PPF Kaplama Sonrası Bakım
            </h2>
            <p className="ppf-paragraph">
              Uygulanan filmin uzun süre berrak kalması ve kenar yapışmasının korunması için genel ve güvenli bakım tavsiyeleri:
            </p>

            <div className="ppf-care-list">
              <div className="ppf-care-item">
                <strong>İlk Günler:</strong> Uygulama sonrasındaki ilk birkaç gün filmin kenarlarının ve yapışkan tabakasının tam oturması için basınçlı yıkamadan kaçınılmalıdır.
              </div>
              <div className="ppf-care-item">
                <strong>Yıkama Mesafesi:</strong> Yüksek basınçlı su tabancası panel kenarlarına çok yakından (en az 35-40 cm mesafe korunmalı) ve dik açıyla tutulmamalıdır.
              </div>
              <div className="ppf-care-item">
                <strong>Kimyasal Seçimi:</strong> Ağır kostik içeren agresif yıkama şampuanları yerine pH dengeli kaliteli otomotiv şampuanları tercih edilmelidir.
              </div>
              <div className="ppf-care-item">
                <strong>Organik Kirler:</strong> Kuş pisliği, ağaç reçinesi ve böcek kalıntıları film yüzeyinde uzun süre kurumaya bırakılmadan yumuşak mikrofiber bezle temizlenmelidir.
              </div>
            </div>
          </section>

          {/* Bölüm 10: SSS */}
          <section className="ppf-section">
            <h2 className="ppf-section-title">
              Sıkça Sorulan Sorular
            </h2>

            <div className="ppf-faq-list">
              <details className="ppf-faq-item">
                <summary className="ppf-faq-question">PPF nedir?</summary>
                <div className="ppf-faq-answer">
                  PPF (Paint Protection Film), aracın orijinal boya yüzeyini yol şartlarından kaynaklanan taş izleri,
                  çizikler ve dış çevresel etkenlere karşı korumaya yardımcı olan şeffaf poliüretan koruma filmidir.
                </div>
              </details>

              <details className="ppf-faq-item">
                <summary className="ppf-faq-question">PPF taş izlerine karşı korur mu?</summary>
                <div className="ppf-faq-answer">
                  Evet, esnek yapısı sayesinde yoldan seken küçük taş ve mıcır darbelerinin kinetik enerjisini soğurarak
                  darbenin alttaki verniğe ve boyaya ulaşmasını engellemeye yardımcı olur. Ancak aşırı şiddetli veya sivri cisim darbelerinde
                  fiziksel limitler bulunmaktadır.
                </div>
              </details>

              <details className="ppf-faq-item">
                <summary className="ppf-faq-question">PPF çizilir mi?</summary>
                <div className="ppf-faq-answer">
                  PPF filmi, boya yerine darbeyi karşılayan ilk temas yüzeyidir. Gündelik kullanımda yüzeyde hafif kılcal izler
                  oluşabilir; ancak bu izler filmin altında bulunan orijinal boyaya sirayet etmez.
                </div>
              </details>

              <details className="ppf-faq-item">
                <summary className="ppf-faq-question">PPF ne kadar süre dayanır?</summary>
                <div className="ppf-faq-answer">
                  Dayanım süresi; aracın park edildiği ortama (kapalı garaj veya açık güneş altı), maruz kaldığı iklim şartlarına,
                  yıllık kilometreye ve yıkama-bakım alışkanlıklarına bağlı olarak değişkenlik gösterir.
                </div>
              </details>

              <details className="ppf-faq-item">
                <summary className="ppf-faq-question">PPF sararır mı?</summary>
                <div className="ppf-faq-answer">
                  Modern kaliteli poliüretan bazlı filmler UV ışınlarına karşı direnç gösterecek şekilde formüle edilir.
                  Düzenli temizlenen ve uygun kimyasallarla bakımı yapılan filmlerde sararma riski minimum düzeydedir.
                </div>
              </details>

              <details className="ppf-faq-item">
                <summary className="ppf-faq-question">PPF nasıl temizlenir?</summary>
                <div className="ppf-faq-answer">
                  pH nötr oto şampuanları, temiz yıkama eldivenleri ve yumuşak mikrofiber kurutma havlularıyla temizlenmelidir.
                  Basınçlı yıkama suyunun panel kenarlarına çok yakın tutulmamasına dikkat edilmelidir.
                </div>
              </details>

              <details className="ppf-faq-item">
                <summary className="ppf-faq-question">PPF üzerine seramik kaplama yapılabilir mi?</summary>
                <div className="ppf-faq-answer">
                  Evet, PPF kaplama üzerine uygun seramik kaplama ürünleri uygulanabilir. Bu uygulama, filmin yüzeyine
                  ekstra hidrofobik su iticilik ve kir tutmama özelliği kazandırarak temizliği daha da kolaylaştırır.
                </div>
              </details>

              <details className="ppf-faq-item">
                <summary className="ppf-faq-question">PPF sökülebilir mi?</summary>
                <div className="ppf-faq-answer">
                  Evet, boya koruma filmleri profesyonel stüdyo ortamında kontrollü ısı yardımıyla sökülebilir. Orijinal fabrika
                  boyasına sahip sağlıklı yüzeylerde doğru teknikle söküldüğünde boyaya zarar vermeden çıkarılabilir.
                </div>
              </details>

              <details className="ppf-faq-item">
                <summary className="ppf-faq-question">PPF hangi bölgelere uygulanır?</summary>
                <div className="ppf-faq-answer">
                  İhtiyaca göre tüm araca uygulanabileceği gibi; en çok taş darbesi alan ön tampon, kaput, çamurluklar,
                  ayna kapakları, marşpiyeller, kapı eşikleri ve farlar gibi spesifik risk bölgelerine de uygulanabilir.
                </div>
              </details>

              <details className="ppf-faq-item">
                <summary className="ppf-faq-question">PPF fiyatı neye göre belirlenir?</summary>
                <div className="ppf-faq-answer">
                  Fiyatlar; aracın model ve boyutuna, kaplanacak panel alanının genişliğine (kısmi veya tam kaplama),
                  panellerin montaj zorluğuna ve uygulama öncesi gereken boya hazırlık işlemlerine göre belirlenir.
                </div>
              </details>
            </div>
          </section>

          {/* Stüdyo Randevu ve Bilgilendirme Kutusu */}
          <div className="ppf-notice-box">
            <span className="ppf-notice-title">BEŞİKTAŞ STÜDYO RANDEVUSU</span>
            <p className="ppf-notice-text">
              Conrad Istanbul Bosphorus içerisindeki stüdyomuzda her araca özel ilgi ve randevu sistemiyle hizmet vermekteyiz.
              Aracınızın kondisyonuna en uygun koruma planını belirlemek için uzmanlarımızla iletişime geçebilirsiniz.
            </p>
          </div>
        </div>

        <Footer />
      </main>
    </div>
  )
}

export default PpfKaplama
